<template>
  <div class="content">
    <ul>
      <li class="radio-btn">
        <div class="radio">
          <input id="radio_month_1" name="radio_month" type="radio" value="month_to_date" v-model="checked" />
          <label for="radio_month_1" class="radio-label" @click="changeMonthToDate">{{ $t('month_to_date') }}</label>
        </div>
      </li>
      <li class="radio-btn">
        <div class="radio">
          <input id="radio_month_2" name="radio_month" type="radio" value="last_month" v-model="checked" />
          <label for="radio_month_2" class="radio-label" @click="onChangeLastMonth">Last</label>
          <input type="number" min="1" class="input--tabs" v-model="fillterForm.lastMonth" @input="onChangeLastMonth" />
          <label>{{ $t('month') }}</label>
        </div>
      </li>
      <li class="radio-btn">
        <div class="radio">
          <input id="radio_month_3" name="radio_month" type="radio" value="from_month" v-model="checked" />
          <label for="radio_month_3" class="radio-label" @click="onChangeFormMonth"></label>
          <input type="number" min="1" class="input--tabs" v-model="fillterForm.formMonth" @input="onChangeFormMonth" />
          <label>{{ $t('month') }}, {{ $t('from') }}</label>
          <select name="month" class="input--tabs" v-model="fillterForm.month" @change="onChangeFormMonth">
            <option v-for="day in listMonth" :key="day.value" :value="day.value">{{ $t(day.name.toLowerCase()) }}</option>
          </select>
          <select name="day" class="input--tabs" v-model="fillterForm.year" @change="onChangeFormMonth">
            <option v-for="day in listYear" :key="day.value" :value="day.value">{{ day.name }}</option>
          </select>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import listDateTime from '@/constants/dateTime'
import tabType from '@/constants/tabType'
import modeQuery from '@/constants/modeQuery'
import moment from 'moment'
import { datetime } from '@/config'

export default {
  name: 'FilterMonth',
  data () {
    return {
      listMonth: listDateTime.month,
      listYear: listDateTime.year,
      checked: null,
      fillterForm: {
        lastMonth: 4,
        formMonth: 4,
        month: new Date().getMonth(),
        year: new Date().getFullYear()
      },
      day: {
        createdAtMin: null,
        createdAtMax: null
      }
    }
  },
  methods: {
    convertMonth (month) {
      return month + 1 <= 9 ? `0${month + 1}` : month + 1
    },
    changeMonthToDate () {
      this.checked = tabType.MONTH.MONTH_TO_DATE
      const startMonth = moment()
        .startOf(datetime.MONTH)
        .toJSON()
      const endMonth = moment().toJSON()
      this.day = {
        createdAtMin: startMonth,
        createdAtMax: endMonth
      }
      this.$emit('changeMonth', this.day, modeQuery.MONTH, 0)
    },
    onChangeLastMonth () {
      this.checked = tabType.MONTH.LAST_MONTH
      if (this.fillterForm.lastMonth !== '') {
        const startMonth = moment()
          .subtract(Number(this.fillterForm.lastMonth), datetime.MONTH)
          .startOf(datetime.MONTH)
          .toJSON()
        const endMonth = moment()
          .endOf(datetime.MONTH)
          .toJSON()
        this.day = {
          createdAtMin: startMonth,
          createdAtMax: endMonth
        }
        this.$emit('changeMonth', this.day, modeQuery.MONTH, Number(this.fillterForm.lastMonth))
      }
    },
    onChangeFormMonth () {
      this.checked = tabType.MONTH.FORM_MONTH
      if (this.fillterForm.formMonth !== '') {
        const date = new Date(`${this.fillterForm.year}-${this.convertMonth(this.fillterForm.month)}-01`)
        const startMonth = moment(date).toJSON()
        const endMonth = moment(date)
          .add(Number(this.fillterForm.formMonth), datetime.MONTH)
          .endOf(datetime.MONTH)
          .toJSON()
        this.day = {
          createdAtMin: startMonth,
          createdAtMax: endMonth
        }
        this.$emit(
          'changeMonth',
          this.day,
          modeQuery.MONTH,
          Number(this.fillterForm.formMonth),
          moment()
            .endOf(datetime.MONTH)
            .unix(),
          moment(this.day.createdAtMax)
            .endOf(datetime.MONTH)
            .unix()
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding: 10px;
  .radio-btn {
    padding-bottom: 10px;
    margin: 0.5rem;
    display: flex;
    align-items: center;
    align-content: center;
  }
  .radio {
    display: flex;
    align-items: baseline;
  }
  label {
    color: #a0a8b4;
  }
  .input--tabs {
    margin: 0 8px;
    height: 32px;
    background-image: none;
    border: 1px solid #ccc;
    width: 70px;
    outline: none;
  }
}
</style>
